import type { OrganizationWallet } from "@/types/wallet";
import { create } from "zustand";

interface OrganizationWalletModalStore {
  open: boolean;
  wallet: OrganizationWallet | null;
  openWallet: (wallet: OrganizationWallet) => void;
  close: () => void;
}

export const useOrganizationWalletModalStore = create<OrganizationWalletModalStore>(set => ({
  open: false,
  wallet: null,
  openWallet: wallet => set({ open: true, wallet }),
  close: () => set({ open: false, wallet: null }),
}));
